import { Button, DialogActions, DialogTitle } from "@mui/material"
import { IRecipe } from "../shared/Recipes"
import GTextField from "../libs/textfield/GTextField"
import { useMemo, useState } from "react"
import FormGroup from "../libs/form/FormGroup"
import FormControl from "../libs/form/FormControl"
import Validators from "../libs/form/Validators"
import { useDialog } from "../libs/dialog/DialogProvider"
import RecipeCache from "../data/RecipeCache"
import { useSnackbar } from "../libs/dialog/SnackbarProvider"
import GIntegerField from "../libs/textfield/GIntegerField"

export interface IAddRecipeProps {
    recipe?:IRecipe
}
export default function AddRecipe(props:IAddRecipeProps){
    const [name,setName] = useState<string>(props.recipe?.name || "")
    const [desc,setDesc] = useState<string>(props.recipe?.description || "")
    const [servings,setServings] = useState<string>(props.recipe?.servings?.toString() || "")
    const {closeDialog} = useDialog()
    const {setSnackbar} = useSnackbar()

    const form = useMemo(() => new FormGroup("recipe", [
        new FormControl("name", [Validators.Required])
    ]), [])
    const onSave = async () => {
        try {
            await RecipeCache.i.addRecipe(name, desc, parseInt(servings)||1)
            closeDialog()
        }catch(e){
            setSnackbar(e)
        }
    }
    return <>
        <DialogTitle>Add a new recipe</DialogTitle>
        <div className="content form">
            <GTextField form={form} controlName="Name" value={name} onChange={e=>setName(e.target.value)} floatLabel="Name"/>
            <GTextField value={desc} onChange={e=>setDesc(e.target.value)} floatLabel="Description" multiline={true}/>
            <GIntegerField value={servings} onChange={e=>setServings(e.target.value)} floatLabel="Servings"/>
        </div>
        <DialogActions>
            <Button variant="text" onClick={closeDialog}>CANCEL</Button>
            <Button variant="contained" color="primary" onClick={onSave}>SAVE</Button>
        </DialogActions>
    </>
}